import InstitutAmadeus from "./InstitutAmadeus";

export default InstitutAmadeus;
